import { render } from "./ProductStatus.vue?vue&type=template&id=bbbe28d2"
import script from "./ProductStatus.vue?vue&type=script&lang=js"
export * from "./ProductStatus.vue?vue&type=script&lang=js"

import "./ProductStatus.vue?vue&type=style&index=0&id=bbbe28d2&lang=css"

import exportComponent from "/home/stephen/DevOps/service-status-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__